// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GithubFilledSvg from "@fishx/icons-svg/es/asn/GithubFilled";
import FishxIcon from '../components/FishxIcon';

var GithubFilled = function GithubFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GithubFilledSvg
  }));
};

GithubFilled.displayName = 'GithubFilled';
export default React.forwardRef(GithubFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GithubFilled.js
// module id = 2867
// module chunks = 0